import { render, staticRenderFns } from "./DeletePage.vue?vue&type=template&id=7467629b&scoped=true&"
import script from "./DeletePage.vue?vue&type=script&lang=js&"
export * from "./DeletePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7467629b",
  null
  
)

export default component.exports